import { render } from "./InputDate.vue?vue&type=template&id=b0379e0a&scoped=true"
import script from "./InputDate.vue?vue&type=script&lang=js"
export * from "./InputDate.vue?vue&type=script&lang=js"

import "./InputDate.vue?vue&type=style&index=0&id=b0379e0a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0379e0a"]])

export default __exports__